import * as React from "react"
import { useSignal } from "@preact/signals-react"
import { Box, Button, CircularProgress, Dialog, Typography } from "@mui/material"

import { SESSIONS_ROUTES } from "@constants"

const REDIRECT_SECONDS = 5

export default function NoDipiAccessModal({ open }) {
	const remaining = useSignal(REDIRECT_SECONDS)

	const goToRetailers = () => { window.location.href = SESSIONS_ROUTES.RETAILERS_APP_URL }

	React.useEffect(() => {
		remaining.value = REDIRECT_SECONDS
		if (!open) return

		const id = setInterval(() => {
			if (remaining.value <= 1) {
				clearInterval(id)
				goToRetailers()
			} else
				remaining.value = remaining.value - 1
		}, 1000)

		return () => clearInterval(id)
	}, [open])

	return <Dialog
		open={!!open}
		PaperProps={{ sx: {
			borderRadius: 4,
			px: 5,
			py: 5,
			maxWidth: 420,
			textAlign: 'center',
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'center',
			gap: 3
		} }}
	>
		<Box sx={{ position: 'relative', display: 'inline-flex' }}>
			<CircularProgress
				variant="determinate"
				value={(remaining.value / REDIRECT_SECONDS) * 100}
				size={104}
				thickness={3}
				sx={{ color: 'primary.main', transition: 'all .3s linear' }}
			/>
			<Box sx={{
				position: 'absolute',
				inset: 0,
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center'
			}}>
				<Typography variant="h3" sx={{ fontWeight: 700, color: 'primary.main', lineHeight: 1 }}>
					{remaining.value}
				</Typography>
			</Box>
		</Box>

		<Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
			<Typography variant="h5" sx={{ fontWeight: 600 }}>
				Access not available
			</Typography>
			<Typography variant="body2" sx={{ color: 'text.secondary', maxWidth: 320 }}>
				Your account doesn't have access to DIP Insights. You'll be redirected to the Retailers app in a few seconds.
			</Typography>
		</Box>

		<Button
			onClick={goToRetailers}
			variant="contained"
			size="large"
			sx={{ borderRadius: 3, px: 4, textTransform: 'none' }}
		>
			Go to Retailers now
		</Button>
	</Dialog>
}
